'use client';
import { cn } from '@ahm/common-helpers';
import { ArrowDownIcon } from 'lucide-react';
import { type ComponentProps, useCallback } from 'react';
import { StickToBottom, useStickToBottomContext } from 'use-stick-to-bottom';
import { Button } from '../button';
export type AIConversationProps = ComponentProps<typeof StickToBottom>;
export const AIConversation = ({
  className,
  ...props
}: AIConversationProps) => (
  <StickToBottom
    className={cn('relative flex-1 overflow-y-auto', className)}
    initial="smooth"
    resize="smooth"
    role="log"
    {...props}
  />
);
export type AIConversationContentProps = ComponentProps<
  typeof StickToBottom.Content
>;
export const AIConversationContent = ({
  className,
  ...props
}: AIConversationContentProps) => (
  <StickToBottom.Content className={cn('p-4', className)} {...props} />
);

export const AIConversationScrollButton = ({
  className,
}: {
  className?: string;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();
  const handleScrollToBottom = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    void scrollToBottom();
  }, [scrollToBottom]);
  return (
    !isAtBottom && (
      <Button
        className={cn(
          'absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full',
          className
        )}
        onClick={handleScrollToBottom}
        size="icon"
        type="button"
        variant="outline"
      >
        <ArrowDownIcon className="size-4" />
      </Button>
    )
  );
};
